module.exports = __webpack_public_path__ + "img/dashboard.5799545e.svg";